import styles from "./ChatInputDropdown.styles.scss";
import {Body} from "../typography";

const ChatInputDropdown = ({ inputContent = '', bottom, onRequestSearch }) => {
  const style = {
    bottom,
    left: 25,
    right: 80
  };

  let options = [];

  if (inputContent.startsWith("#")) {
    const words = inputContent.split(" ");
    const hashtag = '#' + words.find(w => w.startsWith("#")).replace(/\W/g, '');
    options = [...options, {
      label: inputContent === "#" ? "Continue digitando para pesquisar por hashtag..." : `Ver todas as mensagens com a hashtag <b style="word-wrap: break-word">${hashtag}</b>`,
      onClick: () => {
        if (hashtag.length > 1)
          onRequestSearch(hashtag);
      }
    }];
  }

  return options.length > 0 ? <div style={style} className={styles.container}>
    {
      options.map(({label, onClick}) => <div onClick={onClick} className={styles.option}>
        <Body size="body2" dangerouslySetInnerHTML={{__html: label}} />
      </div>)
    }
  </div> : <div />;
};

export default ChatInputDropdown;



// WEBPACK FOOTER //
// ./components/ChatInputDropdown/ChatInputDropdown.js